var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreEssentials2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.689V23.2565C20.8212 23.0165 20.0947 22.9429 19.3816 23.0418C18.6684 23.1408 17.9894 23.4094 17.4016 23.8252C16.8137 24.2409 16.3343 24.7916 16.0034 25.4311C15.6725 26.0705 15.4999 26.78 15.5 27.5L14 27.4993C13.9998 26.5834 14.2092 25.6797 14.6122 24.8573C15.0153 24.0349 15.6012 23.3157 16.3252 22.7548C17.0491 22.1939 17.8919 21.8061 18.7889 21.6212C19.6858 21.4364 20.6132 21.4593 21.5 21.6883V21.689ZM20 20.75C17.5138 20.75 15.5 18.7362 15.5 16.25C15.5 13.7638 17.5138 11.75 20 11.75C22.4862 11.75 24.5 13.7638 24.5 16.25C24.5 18.7362 22.4862 20.75 20 20.75ZM20 19.25C21.6575 19.25 23 17.9075 23 16.25C23 14.5925 21.6575 13.25 20 13.25C18.3425 13.25 17 14.5925 17 16.25C17 17.9075 18.3425 19.25 20 19.25ZM24.5 23.75V21.5H26V23.75H28.25V25.25H26V27.5H24.5V25.25H22.25V23.75H24.5Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreEssentials2);
export default __webpack_public_path__ + "static/media/core_essentials2.656e49866cddbce2e885652868a6d953.svg";
export { ForwardRef as ReactComponent };